// components/NegociosManager.js
import React, { useState } from 'react';
import {
  Button, Input
} from 'reactstrap';
import {
  PlusCircle, Trash2, Package
} from 'lucide-react';
import { saveBusinesses, deleteBusiness } from '../../../helpers/backend';
import './styles/Typifications.css';

const NegociosManager = ({ campaign, onSaved }) => {
  const [newBusiness, setNewBusiness] = useState({ name: '', description: '', products: '' });
  const [isSaving, setIsSaving] = useState(false);

  const handleCreate = async () => {
    if (!newBusiness.name.trim()) return;
    try {
      setIsSaving(true);
      await saveBusinesses({ ...newBusiness, campaign: campaign.id });
      setNewBusiness({ name: '', description: '', products: '' });
      onSaved?.();
    } catch {
      alert('Error creando negocio');
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este negocio?')) return;
    try {
      await deleteBusiness(id);
      onSaved?.();
    } catch {
      alert('Error eliminando negocio');
    }
  };

  return (
    <div>
      <h5 className="section-title mb-3">Negocios</h5>

      <div className="new-business-row mb-3">
        <Input
          placeholder="Nombre"
          value={newBusiness.name}
          onChange={(e) => setNewBusiness({ ...newBusiness, name: e.target.value })}
        />
        <Input
          placeholder="Descripción"
          value={newBusiness.description}
          onChange={(e) => setNewBusiness({ ...newBusiness, description: e.target.value })}
        />
        <Input
          placeholder="Productos (visual futuro)"
          value={newBusiness.products}
          onChange={(e) => setNewBusiness({ ...newBusiness, products: e.target.value })}
        />
        <Button color="primary" onClick={handleCreate} disabled={isSaving}>
          <PlusCircle size={16} className="me-1" />
          Crear
        </Button>
      </div>

      <div className="negocios-list">
        {campaign.negocios.map((n) => (
          <div key={n.id} className="negocio-card">
            <div className="negocio-info">
              <strong>{n.name}</strong>
              <div className="text-muted small">{n.description || 'Sin descripción'}</div>
              {n.products && (
                <div className="producto-chip">
                  <Package size={14} className="me-1" />
                  {n.products}
                </div>
              )}
            </div>
            <Button size="sm" color="danger" onClick={() => handleDelete(n.id)}>
              <Trash2 size={14} />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NegociosManager;
